import { render, staticRenderFns } from "./Recoating.vue?vue&type=template&id=1db77fa4&scoped=true"
import script from "./Recoating.vue?vue&type=script&lang=js"
export * from "./Recoating.vue?vue&type=script&lang=js"
import style0 from "./Recoating.vue?vue&type=style&index=0&id=1db77fa4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db77fa4",
  null
  
)

export default component.exports